// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__1X2W-","sm":"Icon_sm__1r2Qu","md":"Icon_md__1qUlM","lg":"Icon_lg__XV3qN"};